import { inventoryData } from "../constants/inventoryData";
import { api } from "./api";
import { inventoryEndPoints } from "../constants/endpoints";
import { Order } from "../service/cartService";

export const fecthInventoryDetails = async () => {
  try {
    return inventoryData;
  } catch (error) {
    throw new Error("Failed to fetch Inventory Data");
  }
};

export const blockInventoryApi = async (payload: Order) => {
  try {
    await api.put(inventoryEndPoints.lockInventory, payload);
    return true;
  } catch (error: any) {
    throw Error(error);
  }
};

export const unblockInventoryApi = async (payload: Order) => {
  try {
    await api.put(inventoryEndPoints.unlockInventory, payload);
    return true;
  } catch (error: any) {
    throw Error(error);
  }
};
